import { isAdmin } from 'permissions/v1/roles';
import { hasForms } from 'permissions/v1/preferences';
import { noPermissions, canView, canCreate, canUpdate, canDestroy } from 'permissions/v1/index';

const permission = 'DigitalFormTemplate';

const list = (profile) => isAdmin(profile) || canView(permission, profile);
const view = (profile) => isAdmin(profile) || canView(permission, profile);
const create = (profile) => isAdmin(profile) || canCreate(permission, profile);
const update = (profile) => isAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAdmin(profile) || canDestroy(permission, profile);

const permissions = (profile) => {
  if (!hasForms(profile)) return noPermissions;

  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
  };
};

export default permissions;
